'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var textfieldStyle = ['padding-right: 0', 'padding-left: 5px', 'border-color: transparent', 'background: none', 'font-size: 11px', 'line-height: 13px'];

var textFieldLabelStyle = ['font-size: 11px', 'font-weight: bold', 'color: #111', 'padding-left: 5px', 'padding-top: 4px', 'margin-bottom: 0'];

var toggleBtnWidth = 22;
var toggleBtnMarginTop = 48;
var toggleBtnMarginRight = 7;
var toggleBtnMarginLeft = 10;

var windowWidth = 700;
var borderWidth = 14;
var filtersComboBoxWidth = 160;
var windowCmpWidth = windowWidth - borderWidth;

var createdColWidth = 120;
var lastUpdatedColWidth = 120;
var buttonColWidth = 60;
var paddingColWidth = 8;

exports.default = {
    textfieldStyle: textfieldStyle,
    textFieldLabelStyle: textFieldLabelStyle,
    toggleBtnWidth: toggleBtnWidth,
    toggleBtnMarginTop: toggleBtnMarginTop,
    toggleBtnMarginRight: toggleBtnMarginRight,
    toggleBtnMarginLeft: toggleBtnMarginLeft,
    windowWidth: windowWidth,
    borderWidth: borderWidth,
    windowCmpWidth: windowCmpWidth,
    filtersComboBoxWidth: filtersComboBoxWidth,
    createdColWidth: createdColWidth,
    lastUpdatedColWidth: lastUpdatedColWidth,
    buttonColWidth: buttonColWidth,
    paddingColWidth: paddingColWidth
};
//# sourceMappingURL=FavoriteStyle.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/FavoriteStyle.js
 ** module id = 29
 ** module chunks = 0 1
 **/